import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errMsg } from "@/lib/api";
import { formatPlanPrice } from "@/lib/plans";
import { fmtDT } from "@/pages/admin/AdminAccounts";

export default function AdminRequests() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => adminApi.get("/upgrade-requests").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    try {
      await adminApi.patch(`/upgrade-requests/${id}`, { status });
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="admin-requests">
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">Upgrade requests</h1>
      <p className="text-sm text-slate-500">Contact the owner, then mark the request handled.</p>
      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full min-w-[820px] text-left text-sm" data-testid="admin-requests-table">
          <thead className="border-b border-slate-200 bg-slate-50 font-mono text-[10px] uppercase tracking-widest text-slate-500">
            <tr>{["Business", "Owner", "Plan", "Currency", "Price", "Date", "Status", ""].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows?.map((r) => (
              <tr key={r.id} data-testid={`admin-request-row-${r.id}`}>
                <td className="px-4 py-3 font-semibold text-slate-900">{r.business_name}</td>
                <td className="px-4 py-3 font-mono text-xs text-slate-600">{r.owner_email}</td>
                <td className="px-4 py-3" data-testid={`admin-request-plan-${r.id}`}>{r.plan_name}</td>
                <td className="px-4 py-3 font-mono">{r.currency}</td>
                <td className="money px-4 py-3">{r.price ? formatPlanPrice(r.price, r.currency) : "Custom"}</td>
                <td className="px-4 py-3 text-slate-600">{fmtDT(r.created_at)}</td>
                <td className="px-4 py-3"><span className={`rounded-full px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest ${r.status === "pending" ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-600"}`}>{r.status}</span></td>
                <td className="px-4 py-3 text-right">
                  {r.status === "pending" && (
                    <button onClick={() => setStatus(r.id, "contacted")} data-testid={`admin-request-contacted-${r.id}`} className="h-9 rounded-lg border border-slate-300 px-3 text-xs font-semibold hover:border-slate-900">Mark contacted</button>
                  )}
                </td>
              </tr>
            ))}
            {rows?.length === 0 && <tr><td colSpan={8} className="p-8 text-center text-slate-400">No upgrade requests yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
